import React from 'react'
import styled from 'styled-components'
import BuyButton from '../../MwPage/components/BuyButton'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { IDS, priceLine } from '../../MwPage/content'
import { DotGrid, Eyebrow, Hi, Lede, Section } from '../../MwPage/styled'
import TrialCta from '../components/TrialCta'
import { useFocus } from '../focus'
import { centredStyles, DarkPanel, H2, Note, PanelInner, Wrap } from '../styled'

const Inner = styled(PanelInner)`
  ${(props) => props.$centred && centredStyles}
`

/** The closing call to action; its button opens the intake modal, like the offer card's. */
const FinalSection = ({ offer }) => {
  const { finalCta, trial, centred } = useFocus()

  return (
    <Section id={IDS.finalCta} style={{ paddingTop: 0 }}>
      <Wrap>
        <DarkPanel {...useRevealProps()}>
          <DotGrid aria-hidden="true" />
          <Inner $centred={centred}>
            <Eyebrow>{finalCta.eyebrow}</Eyebrow>
            <H2>
              {finalCta.headline} <Hi>{finalCta.headlineAccent}</Hi>
            </H2>
            <Lede>{finalCta.lede}</Lede>
            {trial ? (
              <TrialCta offer={offer} onDark block={!centred} centre={centred} line={finalCta.line || 'closing'} />
            ) : (
              <>
                <BuyButton style={centred ? undefined : { alignSelf: 'flex-start' }}>{finalCta.cta}</BuyButton>
                <Note $onDark>
                  {offer.price && (
                    <>
                      <b>{offer.price}</b>
                      {' · '}
                    </>
                  )}
                  {priceLine.limited} · {priceLine.oneTime} · {priceLine.guarantee}
                </Note>
              </>
            )}
          </Inner>
        </DarkPanel>
      </Wrap>
    </Section>
  )
}

export default FinalSection
